<template>
    <span>
        <span>
            <span @click.prevent="clickElement" v-if="isHtml == false">
                <slot>{{ textMessage }}</slot>
            </span>
            <span @click.prevent="clickElement" @keydown.enter='clickElement' v-else-if="isHtml == true" v-html="textMessage">
            </span>
        </span>
    </span>
</template>

<script setup>
import { ref, onMounted, watch, watchEffect, nextTick, computed } from 'vue'
import router from '../router'
import { useSystemStore } from '@/stores/system'
import { useTranslationStore } from '@/stores/translation'
import { useCurrentElement } from '@vueuse/core'
import EligibleProducts from '@/views/EligibleProducts.vue';

const emit = defineEmits(['reload-data', 'custom-event'])

const systemStore = useSystemStore()
const translationStore = useTranslationStore()
const el = useCurrentElement()
const selectedTab = ref(0)
const selectedDct = ref(null)
const search = ref('')
const page = ref('')
const note = ref('')
const showSaveLink = ref(false)

const props = defineProps({
    elId: { type: String, default: '' },
    position: { type: String, default: 'absolute' },
    defaultText: { type: String, default: '', required: true },
    isHtml: { type: Boolean, default: false },
    elementVisible: { type: Boolean, default: true },
    findAndReplace: { type: Array, default: [] }
})


const dictionaryHeaders = ref([
    { title: "", key: "link" },
    { title: "Id", value: "id" },
    { title: "English", value: "en" },
    { title: "Elements Linked", key: "elementsLinked" }
]);

const elId = ref(0)
const position = ref('absolute')
const textMessage = ref('')
const defaultText = ref('')
const isHtml = ref(false)
const elementVisible = ref(true)

onMounted(() => {
    nextTick(() => {
        getDictionaryLink()
    });

    elId.value = props.elId
    position.value = props.position
    defaultText.value = props.defaultText
    textMessage.value = props.defaultText // getTranslatedText(props.elId)
    isHtml.value = props.isHtml
    elementVisible.value = props.elementVisible

})

watch(
    () => systemStore.selectedLanguage, (val) => {
        getDictionaryLink()
    }
)

watch(
    () => systemStore.defaultDataLoaded, (val) => {
        if (val == true){
            getDictionaryLink()
        } 
    }
)

const getDictionaryLink = () => {
    if (systemStore.defaultDataLoaded === true) {

        textMessage.value = defaultText.value
        var dct = systemStore.languageDictionary.filter(ld => {
            return ld.en.toLowerCase() == defaultText.value.toLowerCase()
        })

        if (dct.length > 0) {
            textMessage.value = dct[0][systemStore.selectedLanguage]
        } else {
            textMessage.value = defaultText.value

            
            // If the default text is not found in the dictionary, we can add it
            // to the dictionary if it is not empty and we are not on the login page (not authenticated)
            if (defaultText.value.trim() != '' && router.currentRoute.value.name != 'login') {
                translationStore.upsertTranslationDictionaryItem(defaultText.value)
            }
        }

        props.findAndReplace.forEach(element => {
            textMessage.value = textMessage.value.replace(element.find, element.replace)                        
        });
    }
}

watch(
    () => props.elementVisible, (val) => {
        getDictionaryLink()
    }
)
watchEffect(
    () => {
        // console.log(props.elementVisible)
    }
)



const clickElement = (ev) => {
    if (ev.target.tagName === "A") {
        var href = ev.target.attributes['href'].value
        window.open(href, '_blank').focus();
    }

    if (ev.target.parentElement.parentElement.parentElement.tagName === "A") {
        var href = ev.target.parentElement.parentElement.parentElement.attributes['href'].value
        window.open(href, '_blank').focus();
    }

    if (ev.target.tagName === "ROUTE") {
        let rn = ev.target.attributes['route-name'].value
        router.push({ name: rn })
    }

    if (ev.target.tagName === "CUSTOM-EVENT") {
        var action = ev.target.attributes['action'].value
        triggerEvent(action)

        // var customEvent1 = ev.target.attributes['event1'].value
        // eval(`${customEvent1}(customEvent1data)`);

    }
}

const triggerEvent = (action) => {
    emit('custom-event', action)
}



</script>

<style>
.loading-enter-active {
    animation: enter 5.2s ease-out;
}

.loading-leave-active {
    animation: enter 5.2s ease-in reverse;
}

@keyframes enter {
    0% {
        opacity: 0%;
        transform: scale(0);
    }

    100% {
        opacity: 100%;
        transform: scale(1);
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: all 2.25s ease;
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
    transform: scale(1.1);
}
</style>